// COMPLETE Homepage recommendations with wine compatibility badges
if (!window.homepageRecommendationsCORRECTED) {
  window.homepageRecommendationsCORRECTED = true;

  function getTranslation(key) {
    const translations = window.theme && window.theme.translations ? window.theme.translations : {};
    const translationKey = 'wine_recommendations_' + key;
    return translations[translationKey] || key;
  }

  async function loadHomepageRecommendations() {
    // Only run on homepage (including language-specific paths like /nl, /fr, /de, etc.)
    const isHomepage = window.location.pathname === '/' || 
                      window.location.pathname === '/nl' || 
                      window.location.pathname === '/nl/' ||
                      window.location.pathname === '/en' || 
                      window.location.pathname === '/en/' ||
                      window.location.pathname === '/fr' || 
                      window.location.pathname === '/fr/' ||
                      window.location.pathname === '/de' || 
                      window.location.pathname === '/de/';
    
    if (!isHomepage) return;

    // Get customer ID
    const metaTag = document.querySelector('meta[name="customer-id"]');
    const customerId = metaTag ? metaTag.getAttribute('content') : null;

    if (!customerId) {
      return;
    }

    const getMetaContent = (name) => {
      const meta = document.querySelector(`meta[name="${name}"]`);
      return meta ? String(meta.getAttribute('content') || '').trim() : '';
    };

    const buildVinpopAuthHeaders = () => {
      const timestamp = getMetaContent('friends-auth-timestamp');
      const signature = getMetaContent('friends-auth-signature');
      if (!customerId || !timestamp || !signature) {
        throw new Error('vinpop_auth_unavailable');
      }

      return {
        'Content-Type': 'application/json',
        'X-Customer-Id': String(customerId),
        'X-Timestamp': timestamp,
        'X-Signature': signature
      };
    };

    try {
      // Get ratings
      const response = await fetch(`https://api.vinpop.fr/api/ratings/getAll?customerId=${customerId}`, {
        headers: buildVinpopAuthHeaders()
      });
      const ratingsArray = await response.json();

      if (!ratingsArray || ratingsArray.length === 0) {
        return;
      }

      // Get loved products
      const lovedProductIds = ratingsArray
        .filter(item => String(item.rating) === "3")
        .map(item => item.id);

      if (lovedProductIds.length === 0) {
        return;
      }

      // Find ONLY products in the two collection carousels (Our Red wines & Our white wines)
      const carousels = document.querySelectorAll('[data-focus-carousel]');
      const allProducts = [];
      carousels.forEach(carousel => {
        const products = carousel.querySelectorAll('li[data-product-id]');
        products.forEach(product => allProducts.push(product));
      });

      if (allProducts.length === 0) {
        return;
      }

      // Process wine recommendations with API calls
      let completedCalls = 0;
      const allApiResponses = [];
      const productCompatibilityMap = {};

      function processAllRecommendations() {
        if (completedCalls !== lovedProductIds.length) return;

        // Get homepage product IDs for comparison
        const homepageProductIds = allProducts.map(el => el.getAttribute('data-product-id'));

        // Process API responses to build compatibility map
        allApiResponses.forEach(responseData => {
          const { response, sourceProductId } = responseData;

          response.forEach(item => {
            // Extract the recommended product ID (the one that's NOT the source product)
            const targetProductId = item.productid1 === String(sourceProductId) ?
              String(item.productid2) :
              String(item.productid1);

            // Convert distance to compatibility percentage (lower distance = higher compatibility)
            const distanceValue = item.perceptive_distance || item.distance;
            const distance = parseFloat(distanceValue);
            
            // Skip if distance is not a valid number
            if (isNaN(distance) || distance === null || distance === undefined) {
              console.warn('Invalid distance for product:', targetProductId, 'raw data:', item);
              return;
            }
            
            const compatibility = Math.max(0, Math.min(100, Math.floor(100 - distance))); // Convert distance to % (0-100)

            // Only store if compatibility is better than existing or doesn't exist
            if (targetProductId && (!productCompatibilityMap[targetProductId] ||
                productCompatibilityMap[targetProductId]?.compatibility < compatibility)) {
              productCompatibilityMap[targetProductId] = {
                compatibility,
                sourceProductId,
                sourceProductName: getProductName(sourceProductId)
              };
            }
          });
        });

        // Display compatibility badges on homepage products
        displayHomepageRecommendations();
      }

      function getProductName(productId) {
        // Try to find product name from DOM for loved products
        const productElement = allProducts.find(el =>
          el.getAttribute('data-product-id') === String(productId)
        );

        if (productElement) {
          const titleElement = productElement.querySelector('h3');
          return titleElement ? titleElement.textContent.trim() : 'a wine you loved';
        }

        return 'a wine you loved';
      }

      function displayHomepageRecommendations() {
        allProducts.forEach(productElement => {
          const productId = productElement.getAttribute('data-product-id');
          if (!productId) return;

          let compatibility = 0;
          let message = '';
          let isLoved = false;

          // Check if this is a loved product
          if (lovedProductIds.includes(productId)) {
            compatibility = 100;
            message = getTranslation('you_loved_it');
            isLoved = true;
          } else if (productCompatibilityMap[productId]) {
            const productData = productCompatibilityMap[productId];
            compatibility = productData.compatibility;

            // Create messages based on score thresholds
            if (compatibility >= 95) {
              message = `${compatibility}% ${getTranslation('professional_tasters')}`;
            } else if (compatibility >= 91) {
              message = `${compatibility}% ${getTranslation('wine_connoisseurs')}`;
            } else if (compatibility >= 85) {
              message = `${compatibility}% ${getTranslation('very_close_profile')}`;
            } else if (compatibility >= 80) {
              message = `${compatibility}% ${getTranslation('related_wine')}`;
            } else {
              message = `${compatibility}% ${getTranslation('different_taste')}`;
            }

            // Add source product info
            if (productData.sourceProductName) {
              message += `, ${getTranslation('because_you_loved')} ${productData.sourceProductName}`;
            }
          }

          // Add the compatibility badge if we have a message
          if (message) {
            addCompatibilityBadge(productElement, message, compatibility, isLoved);
          }
        });
      }

      function addCompatibilityBadge(productElement, message, compatibility, isLoved) {
        // Find the title element
        const title = productElement.querySelector('h3');
        if (!title) return;

        // Remove existing wine recommendation badges to prevent duplicates
        const existingBadges = productElement.querySelectorAll('.wine-recommendation');
        existingBadges.forEach(badge => badge.remove());

        // Create the badge
        const div = document.createElement('div');
        div.className = 'wine-recommendation';
        div.style.cssText = 'color:#666!important;font-style:italic!important;font-size:12px!important;margin-top:4px!important;display:block!important;line-height:1.4!important;';
        div.textContent = message;

        // Add after the title
        title.after(div);

        // Set data attribute for potential styling/sorting
        productElement.setAttribute('data-score', compatibility);
      }

      // Make API calls for each loved product
      lovedProductIds.forEach(lovedProductId => {

        // Use fetch instead of jQuery like in the new version
        fetch('https://api.vinpop.fr/api/wines/getDistance', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: String(lovedProductId)
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('API Response for product', lovedProductId, ':', data);
          if (data && data.length > 0) {
            allApiResponses.push({ response: data, sourceProductId: lovedProductId });
          }
          completedCalls++;
          processAllRecommendations();
        })
        .catch(error => {
          console.error('API Error for product', lovedProductId, ':', error);
          completedCalls++;
          processAllRecommendations();
        });
      });

    } catch (error) {
      console.error('Error in homepage recommendations:', error);
    }
  }

  function scheduleHomepageRecommendations() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadHomepageRecommendations, { timeout: 2500 });
      return;
    }

    window.setTimeout(loadHomepageRecommendations, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHomepageRecommendations, { once: true });
  } else {
    scheduleHomepageRecommendations();
  }
}
